import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  class: "common-link-item-icon"
};
var _hoisted_3 = {
  key: 0,
  class: "common-link-item-num"
};
var _hoisted_4 = ["src"];
import { watch, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { couponsDataFun } from '@/views/couponsList/couponsListUtils.js';
import { isLoginAuthenticated, getAppConfig, getQueryString } from '@/utils/common';
import { useStore } from 'vuex';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { YourAccount } from '@/assets/marketplaces/cn/configs';
var NUMBER_OF_ROW_ICONS = 3; // Add a new style to a row of three icons
var SPECIAL_JUMP_KEY = 'bestSellingRecommendations'; // Get the path:'Path? templateId=xxx', special handling required

export default {
  __name: 'YACommonLinks',
  props: {
    isLogin: Boolean
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/yourAccount/components/YACommonLinks.less');
    var router = useRouter();
    var _couponsDataFun = couponsDataFun(),
      getNcAndRcPromotionsPromise = _couponsDataFun.getNcAndRcPromotionsPromise,
      highlightCouponData = _couponsDataFun.highlightCouponData;
    var store = useStore();
    var NOT_AUTHORIZE_LOGIN_PATH = ['businessLicense', 'todayDeal'];
    var APP_PAGE_CONFIG_PAGES_ENUM = constants.APP_PAGE_CONFIG_PAGES_ENUM,
      YA_COMMON_LINKS = constants.YA_COMMON_LINKS;
    var yaCommonLinks = ref(YA_COMMON_LINKS);
    var jumpToPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        var routerName, imageUrl, key, isLoginStatus, query, specialRoute;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              routerName = item.PATH;
              if (YourAccount.CLICK_EVENTS_MAPPINGS[routerName]) {
                awsRumHandler.recordClickEvent(clickEvents.yourAccountPage[YourAccount.CLICK_EVENTS_MAPPINGS[routerName]]);
              }
              imageUrl = item.IMAGEURL;
              key = item.KEY;
              if (NOT_AUTHORIZE_LOGIN_PATH.includes(routerName)) {
                _context.next = 13;
                break;
              }
              _context.next = 7;
              return isLoginAuthenticated();
            case 7:
              _context.next = 9;
              return isLoginAuthenticated(false);
            case 9:
              isLoginStatus = _context.sent;
              emit('update:isLogin', isLoginStatus);
              if (isLoginStatus) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              query = {};
              if (imageUrl) {
                store.commit('yourAccount/setBusinessLicenseUrl', imageUrl);
              }
              if (key === SPECIAL_JUMP_KEY) {
                specialRoute = routerName.split('?');
                query.templateId = getQueryString('templateId', routerName);
                router.push({
                  name: specialRoute === null || specialRoute === void 0 ? void 0 : specialRoute[0],
                  query
                });
              } else {
                router.push({
                  name: routerName,
                  query
                });
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function jumpToPage(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var totalAvailableCouponsCount = ref(0); // Number of coupons available for use
    var getCouponsCount = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getNcAndRcPromotionsPromise();
            case 2:
              totalAvailableCouponsCount.value = highlightCouponData.value.length;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getCouponsCount() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getSettingPageConfig = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var configData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getAppConfig(APP_PAGE_CONFIG_PAGES_ENUM.SETTING_PAGE);
            case 2:
              configData = _context3.sent;
              yaCommonLinks.value.forEach((link, linkIndex) => {
                link.forEach((item, index) => {
                  if (configData[item.KEY]) {
                    Object.keys(configData[item.KEY]).forEach(key => {
                      if (key !== 'name') {
                        yaCommonLinks.value[linkIndex][index][key.toUpperCase()] = configData[item.KEY][key];
                      }
                    });
                  }
                });
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getSettingPageConfig() {
        return _ref3.apply(this, arguments);
      };
    }();
    onBeforeMount(() => {
      getSettingPageConfig();
      Bridge.registerFn('pageDidAppear', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (props.isLogin) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              getCouponsCount();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })));
    });
    watch(() => props.isLogin, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(isLogin) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              try {
                if (isLogin) {
                  getCouponsCount();
                }
              } catch (error) {
                console.error(error);
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yaCommonLinks.value, (link, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass({
            'ya-common-links-area': true,
            'ya-common-links-three': link.length === NUMBER_OF_ROW_ICONS
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link, (item, itemIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: itemIndex,
            onClick: $event => item.PATH ? jumpToPage(item) : '',
            class: "common-link-item"
          }, [_createElementVNode("div", _hoisted_2, [totalAvailableCouponsCount.value && itemIndex === 0 && index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(totalAvailableCouponsCount.value), 1)) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: item.ICON,
            draggable: "false"
          }, null, 8, _hoisted_4))]), _createElementVNode("span", null, _toDisplayString(item.NAME), 1)], 8, _hoisted_1);
        }), 128))], 2);
      }), 128))]);
    };
  }
};